import { LibraryItem, LibraryItemResponse, LibraryItemsResponse } from '../types';
import { TREES_API_BASE } from './config';

const API_BASE = `${TREES_API_BASE}/api/nodes`;

export async function listNodes(category?: string): Promise<LibraryItemsResponse> {
  try {
    const url = category ? `${API_BASE}?category=${category}` : API_BASE;
    const response = await fetch(url);
    if (!response.ok) throw new Error('Failed to fetch nodes');
    return await response.json();
  } catch (error) {
    return { items: [], error: error.message };
  }
}

export async function getNode(id: string): Promise<LibraryItemResponse> {
  try {
    const response = await fetch(`${API_BASE}/${id}`);
    if (!response.ok) throw new Error('Failed to fetch node');
    return await response.json();
  } catch (error) {
    return { item: null, error: error.message };
  }
}

export async function createNode(node: Omit<LibraryItem, 'id' | 'createdAt' | 'updatedAt'>): Promise<LibraryItemResponse> {
  try {
    const response = await fetch(API_BASE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(node)
    });
    if (!response.ok) throw new Error('Failed to create node');
    return await response.json();
  } catch (error) {
    return { item: null, error: error.message };
  }
}

export async function updateNode(id: string, updates: Partial<LibraryItem>): Promise<LibraryItemResponse> {
  try {
    const response = await fetch(`${API_BASE}/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(updates)
    });
    if (!response.ok) throw new Error('Failed to update node');
    return await response.json();
  } catch (error) {
    return { item: null, error: error.message };
  }
}

export async function deleteNode(id: string): Promise<{ success: boolean; error?: string }> {
  try {
    const response = await fetch(`${API_BASE}/${id}`, {
      method: 'DELETE'
    });
    if (!response.ok) throw new Error('Failed to delete node');
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
}
